import * as THREE from 'three';
import { Text } from 'troika-three-text';
import { convertMmToViewerUnit } from 'Utils/MeasurementUtils';

export class CustomGridHelper extends THREE.LineSegments {
  type: string;
  length: number;
  width: number;
  step: number;

  constructor(length: number, width: number, step: number, color = 'grey') {
    length = Math.ceil(length / step) * step;
    width = Math.ceil(width / step) * step;

    const geometry = new THREE.BufferGeometry();
    const divisionX = Math.ceil(length / step);
    const divisionZ = Math.ceil(width / step);
    const halfLength = length / 2;
    const halfWidth = width / 2;
    const vertices = [];

    const minX = Math.floor(-halfLength / step) * step;
    const maxX = Math.ceil(halfLength / step) * step + 0.01;

    const minZ = Math.floor(-halfWidth / step) * step;
    const maxZ = Math.ceil(halfWidth / step) * step + 0.01;

    // Lines along X (parallel to Z)
    for (let x = minX; x <= maxX; x += step) {
      vertices.push(x, 0, minZ, x, 0, maxZ);
    }

    // Lines along Z (parallel to X)
    for (let z = minZ; z <= maxZ; z += step) {
      vertices.push(minX, 0, z, maxX, 0, z);
    }

    // // Lines along X (parallel to Z)
    // for (let i = 0; i <= divisionX; i++) {
    //   const x = -halfLength + i * step;
    //   vertices.push(x, 0, -halfWidth, x, 0, halfWidth);
    // }
    // // Lines along Z (parallel to X)
    // for (let i = 0; i <= divisionZ; i++) {
    //   const z = -halfWidth + i * step;
    //   vertices.push(-halfLength, 0, z, halfLength, 0, z);
    // }

    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    const material = new THREE.LineBasicMaterial({ color: color });
    super(geometry, material);

    this.type = 'CustomGridHelper';
    this.length = maxX - minX;  //length;
    this.width = maxZ - minZ;  //width;
    this.step = step;
  }

  getGridNumberColor = () => {
    const root = document.body;
    const styles = getComputedStyle(root);

    return styles.getPropertyValue('--canvas-text-color').trim();
  };

  GridNumbers = (axis: string): Text[] => {
    let range = 0;
    switch (axis) {
      case "X":
        range = this.length
        break
      case "Y":
        range = this.width
        break
      case "Z":
        range = this.width
        break
    }
    //console.log("range",range)
    const labels = [];
    let label = new Text();
    for (let i = -range / 2; i <= range / 2; i += this.step) {
      label = new Text();
      label.text = Math.abs(convertMmToViewerUnit(i)).toFixed(0);
      if (axis == "Y") {
        label.text = Math.abs(convertMmToViewerUnit(range / 2 + i)).toFixed(0);
      }
      label.fontSize = 5;
      label.anchorX = 'center';
      label.anchorY = 'middle';
      label.color = this.getGridNumberColor();
      label.transparent = true
      label.opacity = 0.5
      label.position.set(this.position.x, this.position.y, this.position.z);
      if (axis == "X") {
        label.position.x += i;
        label.rotation.x = -Math.PI / 2;
      } else if (axis == "Y") {
        label.position.y += i;
      } else if (axis == "Z") {
        label.position.z += i;
        label.rotation.x = -Math.PI / 2;
      }
      label.sync();
      //console.log(label)
      labels.push(label)
      //sceneRef.current!.add(label);
    }
    return labels;
  };
}